import styled from "@emotion/styled";

import { theme } from "../../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const CrossPath = styled("path")({});

export const Root = styled.div<{ verticalAlign?: string }>(props => ({
    height: 24,
    width: 24,
    display: "inline-block",
    verticalAlign: props.verticalAlign ?? "text-top",
    marginTop: -3,

    [`${CrossPath}`]: {
        stroke: "currentColor",
        strokeWidth: 2,
    },

    ":hover": {
        [`${CrossPath}`]: {
            stroke: "currentColor",
        },
    },
}));

export const RemoveIconWrapper = styled.span<{ disabled?: boolean }>(props => ({
    color: theme(props).icons.color,
    cursor: props.disabled ? "default" : "pointer",

    ":hover": {
        color: theme(props).icons.hoverColor,
    },
}));
